import { HttpErrorResponse } from "@angular/common/http";
import { ViewEncapsulation, OnInit, ViewChild, Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TraceClassDecorator } from "@sentry/angular";
import { Table, LazyLoadEvent, SelectItem } from "primeng";
import { DoctorFilterQuery, DoctorCsvDownload, transaction_status } from "../../../../../models/AccountFilter";
import { PromiseResult, ErrorModel, ServerError } from "../../../../../models/PromiseResult";
import { Specialty } from "../../../../../models/Speciality";
import { AccountsService } from "../../../../../services/accounts.service";
import { CountriesService } from "../../../../../services/countries.service";
import { SpecialityService } from "../../../../../services/speciality.service";
import { getEnumValues } from "../../../../../utilities/utilities.service";
import { DoctorBreadcrumbService } from "../../../shared/breadcrumb.service";
import { MessagesEgdUserQuery } from '../../../../../models/Doctor';
import { DoctorsService } from '../../../../../services/doctors.service';
import { DoctorAccounts } from "src/app/models/Accounts";
import { ProviderStateService } from "src/app/services/provider-state.service";
import { URL } from "url";
import { URLS } from "src/app/constant/constant";

@TraceClassDecorator()
@Component({
    selector: 'app-doctoraccounts',
    templateUrl: './doctoraccounts.component.html',
    styleUrls: ['../../../../../../assets/css/custom-egd.css'],
    encapsulation: ViewEncapsulation.None
})
export class DoctoraccountsComponent implements OnInit {
    query: DoctorFilterQuery;
    download_data: DoctorCsvDownload;
    disabledDates: boolean = true;
    display: boolean = false;
    consultations: SelectItem[] = [];
    ErrorMessage: string = null;
    Transactions: DoctorAccounts[] = [];
    countries: SelectItem[] = [];
    doctor_list: SelectItem[] = [];
    specialties: SelectItem[] = [];;
    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;
    loading: boolean;
    total_records: number = 0;
    maxDate: Date = new Date();
    param = new MessagesEgdUserQuery();
    slug: string = "";
    is_uk_country: boolean = false;
    displayedColumns: string[] = [
        'sr_no',
        'doctor_name',
        'consultation',
        'specialty_name',
        'priority_type',
        'created_at',
        'patient_name',
        'country_name',
        'transaction_no',
        'rendered_actual_amount',
        'rendered_amount'
    ];
    refresh: boolean = false;
    invalid_date_message: boolean = false;
    provider_id: string = "";
    status_list: SelectItem[] = [{ label: 'All', value: null }]
    constructor(
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly accountsService: AccountsService,
        private readonly specialtyservice: SpecialityService,
        private readonly countryService: CountriesService,
        private readonly titleService: Title,
        private readonly doctorsService: DoctorsService,
        private readonly providerStateService: ProviderStateService
    ) {
    }

    private async ResetResponseModel(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }
    async InitFilter(call_api: boolean) {
        this.disabledDates = true;
        this.invalid_date_message = false;
        this.query = {
            user_guid: null,
            page_no: 1,
            records_per_page: 10,
            from_date: null,
            to_date: null,
            country_id: null,
            consultation_type_id: 0,
            specialty_id: null,
            status: null,
            first: 0
        };
        if (call_api)
            await this.GetTransactions(null);
    }
    async ngOnInit() {
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Accounts' },
            { label: 'Doctors' }
        ]);
        this.titleService.setTitle("Dashboard - Doctor Accounts");
        this.provider_id = this.providerStateService.getProviderId();
        this.response = {
            success: null,
            error: null,
            data: null
        };
        if (URLS.IS_UK) {
            this.is_uk_country = true;
        }
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
        this.posting = false;
        this.loading = false;
        getEnumValues(transaction_status).forEach(s => {
            this.status_list.push(
                {
                    label: s,
                    value: s
                }
            )
        })
        this.consultations = [
            {
                label: 'All',
                value: 0
            },
            {
                label: 'Primary Medical Consultation',
                value: 2
            },
            {
                label: 'Follow Up Consultation',
                value: 3
            },
            {
                label: 'Multi Specialty Consultation',
                value: 4
            },
            // {
            //     label: 'Diet and Nutrition',
            //     value: 5
            // }
        ];
        if (!this.is_uk_country) {
            this.consultations.push({
                label: 'Diet and Nutrition',
                value: 5
            });
        } else if(!this.is_uk_country)
        {
            this.consultations.push({
                label: 'Expert Second Medical Opinion',
                value: 1
            });
        }
        else if(this.is_uk_country){
            this.consultations.push({
                label: 'Specialist Consultation',
                value: 1
            });
        }
        this.InitFilter(false);
        await this.GetCountries();
        await this.GetSpecialties(this.provider_id);
        await this.GetDoctors();
        await this.GetTransactions(null);
    }
    async GetCountries() {
        await this.countryService
            .getCountries(this.provider_id)
            .toPromise()
            .then((result) => {
                this.countries = [];
                const temp: SelectItem[] = [{ label: 'All', value: null }];
                for (const country of result)
                    temp.push({
                        label: country.country_name,
                        value: country.id
                    });
                this.countries = temp;
            });
    }

    async GetSpecialties(provider_id?: string) {
        await this.specialtyservice
            .GetAllSupported(undefined, provider_id)
            .toPromise()
            .then((result) => {
                this.specialties = [];
                let data: Specialty[] = result.data;
                const temp: SelectItem[] = [{ label: 'All', value: null }];
                data.forEach((specialty) => {
                    temp.push({
                        label: specialty.specialty_name,
                        value: specialty.id
                    });
                });
                this.specialties = temp;
            });
    }

    async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }
    async GetDoctors(): Promise<void> {
        await this.ResetResultModels();
        this.posting = true;
        await this.doctorsService.findUserList(this.param).toPromise().then(async (result: PromiseResult) => {
            this.doctor_list = [];
            if (result.success) {
                this.doctor_list = [];
                const temp: SelectItem[] = [{ label: 'All', value: null }];
                for (let i = 0; i < result.data.length; i++) {
                    temp.push(
                        {
                            label: result.data[i].first_name + " " + (result.data[i].middle_name == null ? '' : result.data[i].middle_name) + " " + result.data[i].last_name,
                            value: result.data[i].user_guid
                        }
                    )
                }
                this.doctor_list = temp;
            }
            else {
                this.response = result;
            }
            this.posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        })
    }

    setQueryData() {
        if (this.invalid_date_message && ((this.query.from_date != null && this.query.to_date != null) || this.disabledDates)) {
            this.invalid_date_message = false;
        }
        if (!this.disabledDates && (this.query.from_date == null || this.query.to_date == null)) {
            this.invalid_date_message = true;

        }
    }

    async GetTransactions(event: LazyLoadEvent) {
        await this.ResetResponseModel();
        await this.setQueryData();
        this.posting = true;
        this.loading = true;
        if (event != null) {
            this.query.page_no = event.first / event.rows + 1;
            this.query.records_per_page = event.rows;
        }
        else {
            this.query.page_no = 1;
            this.query.first = 0;
        }

        this.Transactions = [];
        await this.accountsService
            .GetDoctorTransactions(this.query)
            .toPromise()
            .then((result) => {
                this.response = result;
                if (this.response.success) {
                    this.total_records = result.data.count;
                    const rec = result.data.rows;
                    let temp: DoctorAccounts[] = [];
                    for (let i = 0; i < rec.length; i++) {
                        temp.push({
                            sr_no:
                                i +
                                1 +
                                (this.query.page_no - 1) *
                                this.query.records_per_page,
                            consultation:
                                rec[i].consultation.priority_type
                                    .consultation_name,
                            doctor_name: rec[i].consultation.p_consultation_appointment.map(d => {
                                return (' ' + d.egd_users.first_name + ' ' + d.egd_users.last_name) || ''
                            }),
                            specialty_name: rec[i].consultation.p_consultation_appointment.map(d => {
                                return d.d_specialty_type.specialty_name
                            }),
                            priority_type:
                                rec[i].consultation.priority_type.priority_type,
                            created_at: rec[i].consultation.created_at,
                            patient_name:
                                rec[i].consultation.accounts.first_name +
                                ' ' +
                                (rec[i].consultation.accounts.middle_name == null ? '' : rec[i].consultation.accounts.middle_name) +
                                ' ' +
                                rec[i].consultation.accounts.last_name,
                            country_name:
                                rec[i].consultation.priority_type.country
                                    .country_name,
                            transaction_no:
                                rec[i].consultation.p_transactions
                                    .transaction_no,
                            transaction_status: rec[i].consultation.p_transactions.status,
                            rendered_amount: rec[i].rendered_amount,
                            rendered_actual_amount: rec[i].rendered_actual_amount
                        });
                    }
                    this.Transactions = temp;
                    this.ErrorMessage = null;
                } else if (!this.response.success) {
                    this.ErrorMessage = result.error.message;
                }
                this.posting = false;
                this.loading = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
                this.loading = false;
            });
    }
    async getDownloadData() {
        await this.setQueryData();
        this.download_data = { ... this.query };
        await this.accountsService.downloadCsv(this.download_data).toPromise()
            .then((response) => {
                let fileName = 'result.csv';
                let blob: Blob = response.body as Blob;
                let a = document.createElement('a');
                a.download = fileName;
                a.href = window.URL.createObjectURL(blob);
                a.click();
            }).catch(err => {
                console.log(err);
            })
    }

}
